export const LINE_DASH_LENGTH = 5;
export const LINE_GAP_LENGTH = 4;
export const LINE_SVG_HEIGHT = 10;
export const LINE_Y_SHIFT = 0.5;
export const NO_OF_DASHES = 3;
